import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const { t } = useTranslation();
  const location = useLocation();

  const allItems = [{ label: t('breadcrumb.home'), href: '/' }, ...items];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: allItems.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://huangguan-sports.com${item.href}` : `https://huangguan-sports.com${location.pathname}`,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-500 py-3">
        {allItems.map((item, index) => (
          <span key={index} className="flex items-center">
            {index > 0 && (
              <i className="ri-arrow-right-s-line mx-1 text-foreground-300"></i>
            )}
            {item.href && index < allItems.length - 1 ? (
              <Link to={item.href} className="hover:text-primary-500 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className={index === allItems.length - 1 ? 'text-foreground-700 font-medium' : ''}>
                {item.label}
              </span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}